/* ============================================================
   Pixkom Geschenkfinder (Task 6.1) — sections/gift-finder.liquid
   State: giftWho / giftOcc / giftBudget (single-select per group,
   click the active chip again to deselect).

   Filtering over the server-rendered candidate grid:
   - Budget: hide cards whose data-price (minor units / cents)
     exceeds the selected limit (bis 5€ → 500 …); „egal" = no limit.
     Cards without a parseable price are never hidden by budget.
   - Für wen / Anlass: tag-ready. Only filters when at least one
     card actually carries a matching tag namespace ("fuer:" /
     "anlass:" in data-tags) — otherwise those chips are
     visual-only so an untagged catalog never collapses to zero.
   ============================================================ */
(function () {
  'use strict';

  var GROUP_KEYS = { who: 'giftWho', occ: 'giftOcc', budget: 'giftBudget' };

  function parseTags(el) {
    var raw = el.getAttribute('data-tags') || '';
    var tags = [];
    raw.split(',').forEach(function (tag) {
      tag = tag.trim();
      if (tag) tags.push(tag);
    });
    return tags;
  }

  function chipValue(key, chip) {
    var raw = chip.getAttribute('data-value') || '';
    if (key === 'giftBudget') {
      var cents = parseInt(raw, 10);
      return isNaN(cents) ? null : cents; // „egal" (blank value) → no limit
    }
    return raw || null;
  }

  function initGiftFinder(root) {
    if (root.dataset.giftFinderReady === 'true') return;
    root.dataset.giftFinderReady = 'true';

    var grid = root.querySelector('[data-gift-grid]');
    if (!grid) return;
    var countEl = root.querySelector('[data-gift-count]');
    var emptyEl = root.querySelector('[data-gift-empty]');
    var state = { giftWho: null, giftOcc: null, giftBudget: null };

    var cards = Array.prototype.map.call(
      grid.querySelectorAll('[data-gift-item]'),
      function (el) {
        var price = parseInt(el.getAttribute('data-price'), 10);
        return { el: el, price: isNaN(price) ? null : price, tags: parseTags(el) };
      }
    );

    // Tag readiness per dimension (graceful degradation, see header).
    var hasWhoTags = cards.some(function (c) {
      return c.tags.some(function (t) { return t.indexOf('fuer:') === 0; });
    });
    var hasOccTags = cards.some(function (c) {
      return c.tags.some(function (t) { return t.indexOf('anlass:') === 0; });
    });

    function apply() {
      var visible = 0;
      cards.forEach(function (c) {
        var show = true;
        if (state.giftBudget !== null && c.price !== null && c.price > state.giftBudget) show = false;
        if (show && state.giftWho && hasWhoTags && c.tags.indexOf(state.giftWho) === -1) show = false;
        if (show && state.giftOcc && hasOccTags && c.tags.indexOf(state.giftOcc) === -1) show = false;
        c.el.hidden = !show;
        if (show) visible += 1;
      });
      if (countEl) countEl.textContent = visible + ' Treffer';
      if (emptyEl) emptyEl.hidden = visible !== 0;
    }

    function setChipState(chip, on) {
      chip.classList.toggle('pk-chip--active', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-gift-group]'), function (group) {
      var key = GROUP_KEYS[group.getAttribute('data-gift-group')];
      if (!key) return;

      // Adopt a server-/mock-rendered pre-active chip into state.
      var preActive = group.querySelector('.pk-chip--active');
      if (preActive) state[key] = chipValue(key, preActive);

      group.addEventListener('click', function (evt) {
        var chip = evt.target.closest('.pk-chip');
        if (!chip || !group.contains(chip)) return;
        var wasActive = chip.classList.contains('pk-chip--active');
        Array.prototype.forEach.call(group.querySelectorAll('.pk-chip'), function (c) {
          setChipState(c, false);
        });
        if (wasActive) {
          state[key] = null; // toggle off = no preference
        } else {
          setChipState(chip, true);
          state[key] = chipValue(key, chip);
        }
        apply();
      });
    });

    var resetBtn = root.querySelector('[data-gift-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        state.giftWho = null;
        state.giftOcc = null;
        state.giftBudget = null;
        Array.prototype.forEach.call(
          root.querySelectorAll('[data-gift-group] .pk-chip--active'),
          function (chip) { setChipState(chip, false); }
        );
        apply();
      });
    }

    apply();
  }

  function initAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-gift-finder]'),
      initGiftFinder
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: section re-render replaces the DOM → re-init.
  document.addEventListener('shopify:section:load', function (evt) { initAll(evt.target); });
})();
